/* Quilted Joy — Cart Progress Bar behavior (extracted from snippets/progress-bar.liquid).
   Loaded once and cached across pages. Per-page config (thresholds, gift product,
   etc.) is injected inline as window.qjPbConfig by the snippet. */
(function () {
  if (window.__qjPbReady) return;
  window.__qjPbReady = true;

  // ── Config — injected inline by Liquid (snippets/progress-bar.liquid) ──
  var CFG = window.qjPbConfig || {
    FREE_SHIPPING_THRESHOLD : 100,
    FREE_GIFT_THRESHOLD     : 0,
    GIFT_ENABLED            : false,
    GIFT_VARIANT_ID         : 0,
    GIFT_PROP_KEY           : '_qj_free_gift',
    GIFT_DISPLAY_NAME       : 'free gift'
  };
  var T1 = Math.round(CFG.FREE_SHIPPING_THRESHOLD * 100);
  var T2 = Math.round(CFG.FREE_GIFT_THRESHOLD * 100);
  var BAR_MAX = CFG.GIFT_ENABLED ? Math.max(T1, T2) : T1;
  var GIFT_FIRST = CFG.GIFT_ENABLED && T2 < T1;

  // ── Money formatting ─────────────────────────────────────────
  // Mirrors Liquid's money_without_trailing_zeros: whole dollars show exactly
  // as entered ($100), fractional amounts keep their cents ($56.50).
  function money(cents) {
    var d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  // ── Messages ─────────────────────────────────────────────────
  function getMessage(cents) {
    if (!CFG.GIFT_ENABLED) {
      if (cents < T1) return 'Spend ' + money(T1 - cents) + ' more for FREE shipping!';
      return "🎉 You've unlocked FREE shipping!";
    }

    if (GIFT_FIRST) {
      if (cents < T2) return 'Spend ' + money(T2 - cents) + ' more to get your FREE ' + CFG.GIFT_DISPLAY_NAME + ', then FREE shipping at ' + money(T1) + '*!';
      if (cents < T1) return '🎁 FREE ' + CFG.GIFT_DISPLAY_NAME + ' unlocked! Spend ' + money(T1 - cents) + ' more for FREE shipping!';
      return "🎉 You've unlocked your FREE " + CFG.GIFT_DISPLAY_NAME + ' AND free shipping!';
    } else {
      if (cents < T1) return 'Spend ' + money(T1 - cents) + ' more for FREE shipping + unlock a FREE ' + CFG.GIFT_DISPLAY_NAME + ' at ' + money(T2) + '*!';
      if (cents < T2) return '🎉 Free shipping unlocked! Spend ' + money(T2 - cents) + ' more to get your FREE ' + CFG.GIFT_DISPLAY_NAME + '!';
      return "🎁 You've unlocked FREE shipping AND your FREE " + CFG.GIFT_DISPLAY_NAME + '!';
    }
  }

  // ── Qualifying total (excludes auto-added gift item) ────────
  function getQualifyingCents(cartData) {
    if (!cartData || !cartData.items) return 0;
    var total = 0;
    for (var i = 0; i < cartData.items.length; i++) {
      var item = cartData.items[i];
      var isGift = CFG.GIFT_ENABLED
                   && String(item.variant_id) === String(CFG.GIFT_VARIANT_ID)
                   && item.properties && item.properties[CFG.GIFT_PROP_KEY];
      if (!isGift) total += (item.final_line_price || 0);
    }
    return total;
  }

  // ── Update every bar instance on the page ───────────────────
  function updateAllBars(cartData) {
    var cents = getQualifyingCents(cartData);
    var pct   = Math.min((cents / BAR_MAX) * 100, 100).toFixed(2);
    var msg   = getMessage(cents);

    document.querySelectorAll('.qj-pb-wrapper').forEach(function (wrapper) {
      var fill  = wrapper.querySelector('.qj-pb__fill');
      var m1    = wrapper.querySelector('[data-milestone="shipping"]');
      var m2    = wrapper.querySelector('[data-milestone="gift"]');
      var msgEl = wrapper.querySelector('.qj-pb__message');
      var track = wrapper.querySelector('.qj-pb__track');

      if (fill)  fill.style.width = pct + '%';
      if (m1)    m1.classList.toggle('is-complete', cents >= T1);
      if (m2)    m2.classList.toggle('is-complete', cents >= T2);
      if (msgEl) msgEl.innerHTML = msg;
      if (track) track.setAttribute('aria-valuenow', cents);
    });
  }

  // ── Fetch cart then update ───────────────────────────────────
  function fetchAndUpdate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateAllBars(cart); })
      .catch(function (e) { console.warn('[QJ Progress Bar]', e); });
  }

  var _t;
  function debouncedFetch() {
    clearTimeout(_t);
    _t = setTimeout(fetchAndUpdate, 400);
  }

  // ── Patch theme's own cart update function ───────────────────
  function patchRerenderUpsell() {
    var _orig = window.rerenderUpsellContainer;
    window.rerenderUpsellContainer = function (data) {
      if (_orig) _orig.call(this, data);
      debouncedFetch();
    };
  }
  if (typeof window.rerenderUpsellContainer === 'function') {
    patchRerenderUpsell();
  } else {
    var _pollCount = 0;
    var _poll = setInterval(function () {
      if (typeof window.rerenderUpsellContainer === 'function') {
        patchRerenderUpsell(); clearInterval(_poll);
      } else if (++_pollCount > 20) { clearInterval(_poll); }
    }, 100);
  }

  document.addEventListener('cart:updated',         function (e) { if (e.detail && e.detail.cart) updateAllBars(e.detail.cart); else debouncedFetch(); });
  document.addEventListener('cart-drawer:open',     debouncedFetch);
  document.addEventListener('shopify:section:load', debouncedFetch);

  var _drawerEl = document.getElementById('CartDrawer');
  if (_drawerEl && window.MutationObserver) {
    new MutationObserver(function () { debouncedFetch(); }).observe(_drawerEl, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchAndUpdate);
  } else {
    fetchAndUpdate();
  }
})();
